export default __webpack_public_path__ + "static/media/kitchen4-afterD-480w.86cb4744.png";